import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class ProductionFloorNodeModel extends Node {
  constructor(device = {}, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.ProductionFloor,
    });
  }
}
